import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { loginActions } from './login.actions';
import { tokenInit, loginInit } from './login.dtos';

const loginReducer = combineReducers({
  loginRequest: createReducer(loginInit)
    .handleAction(
      [
        loginActions.request,
      ], (state, action) => action.payload),

  loginSuccess: createReducer(tokenInit)
    .handleAction(
      [
        loginActions.success,
      ], (state, action) => action.payload),

  loginError: createReducer('')
    .handleAction(
      [
        loginActions.failure,
      ], (state, action) => action.payload)
});

export default loginReducer;